export function parseNumber(value: string): number {
  if (value.match(/^\d{1,3}(\.\d{3})*,\d{2}$/)) {
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }
  if (value.match(/^\d{1,3}(,\d{3})*\.\d{2}$/)) {
    return parseFloat(value.replace(/,/g, ''));
  }
  return parseFloat(value);
}

export function formatToBRL(value: number | string, visible = true): string {
  if (!visible) return 'R$ •••••';
  const numeric = parseNumber(`${value}`);
  const safe = Number.isFinite(numeric) ? numeric : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
}

export function formatCentsToBRL(cents: number, visible = true): string {
  if (!visible) return 'R$ •••••';
  const safe = Number.isFinite(cents) ? cents / 100 : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
}

export function formatCentsToBRLCompact(cents: number, visible = true): string {
  if (!visible) return 'R$ •••••';
  const safe = Number.isFinite(cents) ? cents / 100 : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
}

export function formatPercentValueToString(value?: number): string {
  if (!value && value !== 0) return '-';
  const safeValue = typeof value === 'number' ? value : Number(value);
  const formatted = safeValue.toFixed(2).replace('.', ',');
  return `${formatted}%`;
}

export function formatPercentValueToNumber(value?: string): number {
  return Number(`${value}`.replace(/\./g, '').replace(',', '.'));
}
